import { useTranslation } from 'react-i18next';

export default function ContactSection() {
  const { t } = useTranslation();

  return (
    <section id="contact" className="relative w-full py-20 md:py-32 bg-dark-900">
      <div className="absolute inset-0 bg-gradient-to-b from-neon-blue/5 via-transparent to-transparent" />
      <div className="w-full px-4 md:px-6 lg:px-12 relative z-10">
        <div className="max-w-2xl mx-auto text-center mb-10 md:mb-14">
          <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white">
            {t('contact.title1')}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-blue to-neon-purple">
              {t('contact.title2')}
            </span>{' '}
            {t('contact.title3')}
          </h2>
          <p className="mt-4 text-sm md:text-base text-gray-400 max-w-md mx-auto">
            {t('contact.subtitle')}
          </p>
        </div>

        <div className="max-w-lg mx-auto">
          <div className="p-6 md:p-8 rounded-3xl bg-dark-500/80 backdrop-blur-sm border border-white/5 flex flex-col items-center gap-5">
            <a
              href="mailto:quaronsoftware@proton.me"
              className="w-full flex items-center gap-4 px-5 py-4 rounded-2xl bg-dark-400 border border-white/5 hover:border-neon-blue/30 hover:bg-dark-300 transition-all duration-300 group"
            >
              <span className="w-12 h-12 rounded-xl bg-neon-blue/10 flex items-center justify-center text-neon-blue group-hover:bg-neon-blue/20 transition-all duration-300">
                <i className="ri-mail-line text-xl" />
              </span>
              <div className="text-left">
                <p className="text-xs text-gray-500 mb-0.5">Email</p>
                <p className="text-sm md:text-base text-white font-medium group-hover:text-neon-blue transition-colors duration-300">
                  quaronsoftware@proton.me
                </p>
              </div>
              <i className="ri-arrow-right-up-line ml-auto text-gray-600 group-hover:text-neon-blue transition-colors duration-300" />
            </a>

            <a
              href="https://t.me/notgucul"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full flex items-center gap-4 px-5 py-4 rounded-2xl bg-dark-400 border border-white/5 hover:border-neon-blue/30 hover:bg-dark-300 transition-all duration-300 group"
            >
              <span className="w-12 h-12 rounded-xl bg-neon-blue/10 flex items-center justify-center text-neon-blue group-hover:bg-neon-blue/20 transition-all duration-300">
                <i className="ri-telegram-line text-xl" />
              </span>
              <div className="text-left">
                <p className="text-xs text-gray-500 mb-0.5">Telegram</p>
                <p className="text-sm md:text-base text-white font-medium group-hover:text-neon-blue transition-colors duration-300">
                  @notGucul
                </p>
              </div>
              <i className="ri-arrow-right-up-line ml-auto text-gray-600 group-hover:text-neon-blue transition-colors duration-300" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}